import React, { useState } from 'react';

import { Box, IconButton, Typography } from '@mui/material';

import {
  ArrowBackOutlined,
  AutoAwesome,
  Bookmark,
  ContentCopy,
  Edit,
  ThumbDownOffAlt,
  ThumbDownOutlined,
  ThumbUpOffAlt,
  ThumbUpOutlined,
  YoutubeSearchedFor,
} from '@mui/icons-material';

import { useCopilotContext } from '../../contexts/CopilotContext';
import { StyledImageOverlay } from '../../pages/VirtualSession/styles';
import { COLORS } from '../../utils/colors';
import { useKnowledgeBaseStyles } from './styles';

interface SearchResultsProps {
  search: string;
  openCopilot: () => void;
}

const SearchResults = ({ openCopilot, search }: SearchResultsProps) => {
  const styles = useKnowledgeBaseStyles();
  const { bookList, documentParagraphMapRef, searchResults, setViewDocument } =
    useCopilotContext();
  // const { profile } = useBookingsContext();
  const [viewResult, setViewResult] = useState<number>(0);
  const [imagesOnly, setImagesOnly] = useState(false);

  const totalImages = searchResults?.scores.reduce(
    (acc: number, score: any) => {
      const did = score.did;
      const pid = `${did}-${score.idx}`;
      const paragraph = documentParagraphMapRef.current?.get(pid);

      return paragraph?.ref?.illustrations
        ? acc + paragraph.ref.illustrations.length
        : acc;
    },
    0,
  );

  const userFeedback = (rating: string) => {};

  console.log('::::SearchResults: ', searchResults, `next: ${viewResult}`);

  return (
    <>
      <Box sx={styles.srback}>
        <Box
          width={'100%'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <Typography>
            <span style={{ fontWeight: '600', marginRight: '1rem' }}>
              SEARCH{' '}
            </span>
            {`"${search}"`}
          </Typography>

          <Box display={'flex'} justifyContent={'flex-end'}>
            <Typography
              onClick={() => setImagesOnly(false)}
              sx={{
                cursor: 'pointer',
                marginLeft: '1rem',
                marginRight: '1rem',
                textDecoration: !imagesOnly ? 'Underline' : null,
                color: '#53617a',
              }}
              fontWeight={500}>
              All
            </Typography>
            <Typography
              onClick={() => setImagesOnly(true)}
              sx={{
                cursor: 'pointer',
                textDecoration: imagesOnly ? 'Underline' : null,
                color: '#53617a',
              }}
              fontWeight={500}>
              Images
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box marginLeft={'1rem'} marginBottom={'1rem'}>
        <Typography fontSize={'0.75rem'}>
          {imagesOnly ? totalImages : searchResults.scores.length} Results
        </Typography>
      </Box>
      {!imagesOnly && (
        <Box sx={styles.searchResult}>
          {searchResults?.scores.map((score: any, index: number) => {
            const did = score.did;
            const pid = `${did}-${score.idx}`;
            const paragraph = documentParagraphMapRef.current?.get(pid);
            const document = bookList.find((item) => did === item.did);

            if (!document || !paragraph) return null;

            const images = paragraph.ref.illustrations.map((iid, idx) => (
              <Box
                key={`illustration-${idx}`}
                height={'18rem'}
                sx={{ display: 'flex', width: '18rem', position: 'relative' }}>
                <img
                  src={`${window._env_?.LIBRARY_BASE_URL || process.env.REACT_APP_LIBRARY_BASE_URL}/${document.key}/img/${iid}.png`}
                  alt={`Illustration ${iid}`}
                  style={styles.img}
                  loading="lazy"
                />
                <StyledImageOverlay sx={styles.imageOverlay}>
                  <Box
                    display={'flex'}
                    justifyContent={'flex-end'}
                    alignItems={'flex-end'}
                    maxWidth={'18rem'}
                    width={'18rem'}
                    height={'18rem'}
                    marginBottom={'0.5rem'}>
                    <ThumbUpOutlined sx={styles.up} />
                    <ThumbDownOutlined sx={styles.down} />
                  </Box>
                </StyledImageOverlay>
              </Box>
            ));

            return (
              <Box
                key={`search-result-${did}-${index}`}
                sx={{ marginBottom: '1rem' }}>
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  marginBottom={'1rem'}>
                  <Box sx={{ marginLeft: 'auto' }}>
                    {/* {profile?.settings?.dev === true && (
                      <AutoAwesome
                        onClick={() => openCopilot()}
                        sx={styles.srbutton}
                      />
                    )} */}
                    <Bookmark sx={styles.srbutton} />
                    {/* <KeyboardArrowLeftOutlined
                      onClick={() =>
                        setViewResult(
                          viewResult === 0
                            ? searchResults?.scores.length - 1
                            : viewResult - 1,
                        )
                      }
                      sx={styles.srbutton}
                    />
                    <KeyboardArrowRightOutlined
                      onClick={() =>
                        setViewResult(
                          viewResult < searchResults?.scores.length - 1
                            ? viewResult + 1
                            : 0,
                        )
                      }
                      sx={styles.srbutton}
                    /> */}
                  </Box>
                </Box>
                <Box display={'flex'}>
                  <Box sx={styles.srbook}>
                    <img
                      src={`${window._env_?.LIBRARY_BASE_URL || process.env.REACT_APP_LIBRARY_BASE_URL}/${document.key}/img/${document.images[0]}`}
                      alt={`${document.title} cover`}
                      style={styles.srcover}
                    />
                  </Box>
                  <Box width={'100%'}>
                    <Box display={'flex'} alignItems={'center'}>
                      <Typography width={'100%'} marginLeft={'auto'}>
                        {document.title}
                      </Typography>
                      <Box display={'flex'} marginLeft={'auto'}>
                        <IconButton onClick={() => userFeedback('Good')}>
                          <ThumbUpOffAlt />
                        </IconButton>
                        <IconButton onClick={() => userFeedback('Poor')}>
                          <ThumbDownOffAlt />
                        </IconButton>
                      </Box>
                    </Box>
                    <Typography>Page {paragraph.ref.page}</Typography>
                  </Box>
                </Box>

                <Box
                  sx={{ marginBottom: '1rem' }}
                  onClick={() => {
                    document &&
                      paragraph &&
                      setViewDocument({
                        ...document,
                        searchResult: paragraph.idx,
                      });
                  }}>
                  <Typography
                    fontWeight={'500'}
                    textTransform={'lowercase'}
                    fontSize={'0.9rem'}
                    paddingTop={'1rem'}
                    paddingLeft={'1rem'}>
                    {paragraph.ref.section} {paragraph.ref.subtitle}
                  </Typography>
                  <Typography
                    fontSize={'0.9rem'}
                    padding={'1rem'}
                    paddingTop={'0.3rem'}>
                    {paragraph.text}
                  </Typography>
                  <Box
                    display={'flex'}
                    justifyContent={'space-evenly'}
                    flexWrap={'wrap'}>
                    {images}
                  </Box>
                </Box>

                <Box sx={styles.srbuttons} display={'flex'} width={'100%'}>
                  <Box sx={styles.srrow}>
                    <Box display={'flex'}>
                      <IconButton>
                        <ArrowBackOutlined sx={styles.srbutton} />
                      </IconButton>
                      <IconButton>
                        <YoutubeSearchedFor sx={styles.srbutton} />
                      </IconButton>
                      <IconButton>
                        <ContentCopy sx={styles.srbutton} />
                      </IconButton>
                      <IconButton>
                        <Edit sx={{ color: COLORS.MEDIUM_GRAY }} />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
      )}

      {imagesOnly && (
        <Box sx={styles.searchResult}>
          {searchResults?.scores.map((score: any, index: number) => {
            const did = score.did;
            const pid = `${did}-${score.idx}`;
            const paragraph = documentParagraphMapRef.current?.get(pid);
            const document = bookList.find((item) => did === item.did);

            if (!document || !paragraph) return null;
            const images = paragraph.ref.illustrations.map((iid, idx) => (
              <Box
                key={`illustration-${idx}`}
                height={'18rem'}
                sx={{ display: 'flex', width: '18rem', position: 'relative' }}>
                <img
                  src={`${window._env_?.LIBRARY_BASE_URL || process.env.REACT_APP_LIBRARY_BASE_URL}/${document.key}/img/${iid}.png`}
                  alt={`Illustration ${iid}`}
                  style={styles.img}
                  loading="lazy"
                />
                <StyledImageOverlay sx={styles.imageOverlay}>
                  <Box
                    display={'flex'}
                    justifyContent={'flex-end'}
                    alignItems={'flex-end'}
                    maxWidth={'18rem'}
                    width={'18rem'}
                    height={'18rem'}
                    marginBottom={'0.5rem'}>
                    <ThumbUpOutlined sx={styles.up} />
                    <ThumbDownOutlined sx={styles.down} />
                  </Box>
                </StyledImageOverlay>
              </Box>
            ));
            if (images.length === 0) return null;
            return (
              <Box
                key={`search-result-images-${did}-${index}`}
                sx={{
                  marginBottom: '1rem',
                }}>
                <Box sx={styles.srbook}>
                  <img
                    src={`${window._env_?.LIBRARY_BASE_URL || process.env.REACT_APP_LIBRARY_BASE_URL}/${document.key}/img/${document.images[0]}`}
                    alt={`${document.title} cover`}
                    style={styles.srcover}
                  />
                </Box>
                <Box width={'100%'}>
                  <Box display={'flex'} alignItems={'center'}>
                    <Typography width={'100%'} marginLeft={'auto'}>
                      {document.title}
                    </Typography>
                    <Box display={'flex'} marginLeft={'auto'}>
                      <IconButton onClick={() => userFeedback('Good')}>
                        <ThumbUpOffAlt />
                      </IconButton>
                      <IconButton onClick={() => userFeedback('Poor')}>
                        <ThumbDownOffAlt />
                      </IconButton>
                    </Box>
                  </Box>
                  <Typography>Page {paragraph.ref.page}</Typography>
                </Box>
                <Box
                  sx={{ display: 'flex', justifyContent: 'space-evenly' }}
                  marginTop={'1rem'}
                  paddingBottom={'1rem'}
                  borderBottom={`2px solid ${COLORS.LIGHT_GRAY}`}>
                  {images}
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
    </>
  );
};

export default SearchResults;
